// extracted by mini-css-extract-plugin
module.exports = {"at-stopwatchcontent":"TicTacToe_at-stopwatchcontent__3MNGt","at-calculatorholder":"TicTacToe_at-calculatorholder__3GQ1t","at-opancalculator":"TicTacToe_at-opancalculator__Ku0px"};